import { createFileRoute } from "@tanstack/react-router";

import { useFeatureIsOn } from "@/app/featureFlags";
import { BannersPlacement } from "@/components/BannersPlacement/BannersPlacement";
import { Footer } from "@/components/Footer/Footer";
import { PatternBackground } from "@/components/Icons";
import { SearchNavigationButtons } from "@/components/SearchNavigationButtons/SearchNavigationButtons";
import { MainSearchWhatsAppBanner } from "@/components/WhatsApp/WhatsAppBanners";
import { TripCarousel } from "@/features/trips/components/TripCarousel";
import { BannersPlacementSlug } from "@/types/enums";
import { isProduction } from "@/utils/constants";

export const Route = createFileRoute("/_authenticated/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <main className="main">
      <div className="relative flex w-full items-center justify-center overflow-clip bg-surface-accent-stronger pt-6 pb-12">
        <PatternBackground className="absolute inset-0" />

        {!isProduction ? (
          <div className="absolute start-0 top-0 flex w-full justify-center">
            <div className="rounded-b-md bg-surface-accent-strong/75 px-2 py-0.5 text-xs text-white/75 capitalize">
              {import.meta.env.VITE_PUBLIC_ENVIRONMENT}
            </div>
          </div>
        ) : null}

        <SearchNavigationButtons />
      </div>

      <div className="relative -mt-6 flex flex-col gap-4.5 rounded-t-3xl bg-surface-background pt-6">
        <BannersPlacement slug={BannersPlacementSlug.HOMEPAGE_BELOW_SEARCH} />

        {useFeatureIsOn("trips-flow") ? <TripCarousel /> : null}

        <div className="px-main">
          <MainSearchWhatsAppBanner />
        </div>
      </div>

      <Footer />
    </main>
  );
}
